<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="contract.product_name+' for '+contract.seller_name+' [Deactivate Product Contract]  - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>

                    <li class="breadcrumb-item">
                        <router-link :to="`/products/view/${contract.product_id}`">{{ contract.product_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contract.seller_type == 'Agent'">
                        <router-link :to="`/agents/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item" v-else-if="contract.seller_type == 'Agency'">
                        <router-link :to="`/agencies/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/contracts/view/${contract.id}`">
                            {{ contract.writing_nbr ? contract.writing_nbr : 'View Contract' }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <i class="fa fa-trash"></i> Deactivate
                    </li>

                </ol>
            </nav>

            <h4 class="page-header">
                Deactivate: {{ contract.product_name }} for {{ contract.seller_name }}
            </h4>

            <div class="row mb-3">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Deactivate Contract:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <strong>Warning:</strong> You are about to deactiate this contract. This will mark it inactive and it will appear as such on all lists and reports. No data will be deactivated.
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-sm btn-warning" v-on:click="deactivateContract()">
                        Deactivate Contract
                    </button>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                id: this.$route.params.id,
                userTimezone: this.$root.timezone,
                contract: {},
                errors: {},
            }
        },

        computed: {
            canEdit(){
                //Check Permissions
                return this.$root.hasPermission('contracts.manage');
            },
        },

        methods: {

            getContract(){
                //Send it
                this.$http.get('/contracts/view/' + this.id)
                    .then(response => {
                        //Set the contract
                        this.contract = response.data.contract;
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deactivateContract(){
                //Send it
                this.$http.post('/contracts/deactivate/' + this.id)
                    .then(response => {
                        //Alert
                        this.$toastr.s('Contract Deactivated');

                        //Fire it
                        this.$router.push('/contracts/view/'+this.contract.id);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Deactivate Contract');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted() {
            //get the contract?
            this.getContract();
        }
    }
</script>
